// extracted by mini-css-extract-plugin
module.exports = {"arrowKeyImage":"HowToMove_arrowKeyImage__3rJ5L","lookAroundImage":"HowToMove_lookAroundImage__fTh0m","closeDiv":"HowToMove_closeDiv__1reJo"};